import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectorRef, NgModule   } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { FilterModule, FilterExpression } from '@progress/kendo-angular-filter';
import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { FilterSharingService } from 'app/services/filter-sharing.service';
import { GridService } from 'app/services/grid.service';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from "@progress/kendo-angular-dateinputs";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { LabelModule } from "@progress/kendo-angular-label";



@Component({
  selector: 'app-drake-scope-search',
  standalone: true,
  imports: [
    CommonModule,
    FilterModule,
    ButtonModule,
    DropDownsModule,
    FormsModule,
    DatePickerModule,
    InputsModule,
    LabelModule
  ],
  templateUrl: './drake-scope-search.component.html',
  styleUrls: ['./drake-scope-search.component.scss']
})
export class DrakeScopeSearchComponent implements OnInit {
  @ViewChild("template", { static: true })
  public template: TemplateRef<any>;

  public filters: any[] = [];
  public filterValue: CompositeFilterDescriptor = { logic: 'and', filters: [] };
  public dropDownData: { [key: string]: any[] } = {}; // Per memorizzare i dati del dropdown
  private viewCode: string;
  public dropDownValues: any[];

  constructor(
    private filterSharingService: FilterSharingService,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private gridService: GridService
  ) {
    this.viewCode = this.route.snapshot.paramMap.get('viewCode');
    console.log('Constructor: viewCode =', this.viewCode);
  }

  ngOnInit(): void {
    this.loadFields();
  }

  loadFields(): void {
    if (!this.viewCode) {
      console.error('No viewCode provided');
      return;
    }
    console.log('Loading fields for viewCode:', this.viewCode);
    this.gridService.getScopeView(this.viewCode).subscribe(
      (viewConfig: any) => {
        console.log('Received viewConfig:', viewConfig);
        if (viewConfig && viewConfig.fields) {
          this.filters = viewConfig.fields
            .filter((field: any) => field.columnName || field.fieldCode) // Filtra campi senza `columnName` o `fieldCode`
            .map((field: any) => {
              const fieldName = field.columnName || field.fieldCode;
              console.log('Setting filter field:', fieldName);

              this.getDropDownData(field.fieldCode); // Carica i dati del dropdown
              return {
                field: fieldName,
                title: field.header,
                editor: this.getEditor(field.fieldType, field.fieldControlType, field.fieldCode),
                fieldControlType: field.fieldControlType,
                operators: this.getOperators(field.fieldType, field.fieldControlType),
                fieldCode: field.fieldCode
              };
          });
          console.log('Mapped filters:', this.filters);
        } else {
          console.error('No fields found in viewConfig:', viewConfig);
        }
      },
      (error) => {
        console.error('Error loading fields', error);
      }
    );
}



  getEditor(fieldType: string, fieldControlType: string, fieldCode: string): string {
    var editor = null;
    if(fieldControlType === 'DROPDOWNLIST' || fieldControlType === 'COLORPICKER'){
      editor = 'string';
    }
    
    // Log dell'editor scelto per ogni campo
    console.log(`Editor for ${fieldCode}:`, editor);
    
    if (editor === 'string') {
        this.getDropDownData(fieldCode); // Carica i dati del dropdown
        return editor;
      
    }
    
    if (fieldControlType === 'HTML' || fieldControlType === 'OBJECT' || fieldControlType === 'FILE' || fieldControlType === 'MASK' || fieldControlType === 'CODEEDITOR') {
      return 'string';
    }
    if (fieldControlType === 'RATING' || fieldControlType === 'SLIDER' || fieldType === 'NUMBERIC' || fieldType === 'DECIMAL' || fieldType === 'INT') {
      return 'number';
    }
    if (fieldType === 'BOOLEAN') {
      return 'boolean';
    }
    if (fieldType === 'DATEPICKER' || fieldType === 'DATETIME') {
      return 'date';
    }
    return 'string';
  }

  getOperators(fieldType: string, fieldControlType: string): string[] {
    if (fieldControlType === 'DROPDOWNLIST' || fieldControlType === 'COLORPICKER') {
      return ["eq", "neq"];
    }

    if (fieldControlType === 'HTML' || fieldControlType === 'OBJECT' || fieldControlType === 'FILE' || fieldControlType === 'MASK' || fieldControlType === 'CODEEDITOR') {
      return ["eq", "neq", "contains", "doesnotcontain", "startswith", "endswith"];
    }

    if (fieldControlType === 'RATING' || fieldControlType === 'SLIDER' || fieldType === 'NUMBERIC' || fieldType === 'DECIMAL' || fieldType === 'INT') {
      return ["eq", "neq", "lt", "lte", "gt", "gte"];
    }

    if (fieldType === 'BOOLEAN') {
      return ["eq", "neq"];
    }

    if (fieldType === 'DATEPICKER' || fieldType === 'DATETIME') {
      return ["eq", "neq", "lt", "lte", "gt", "gte"];
    }

    return ["eq", "neq", "contains", "doesnotcontain", "startswith", "endswith"];
  }
  
  onFilterChange(value: CompositeFilterDescriptor): void {
    console.log("OnFilterChange Value", value);
    // Aggiorna `filterValue` con il valore corrente di `value`
    this.filterValue = { ...value };

    // Debugging per confermare l'aggiornamento
    console.log("Aggiornato filterValue:", this.filterValue);

}
editorValueChange( value,
  currentItem: FilterDescriptor,
  filterValue: CompositeFilterDescriptor
): void {
  currentItem.value = value;
  console.log("editorValue filterValue",filterValue, "CurrentItem",currentItem);
}

onTextboxInputChange(value: string, field: string): void {
  console.log('Textbox input changed for field:', field, 'with value:', value);

  const filters = this.filterValue.filters as FilterDescriptor[];

  // Trova un filtro esistente per il campo specificato
  const existingFilterIndex = filters.findIndex(f => f.field === field);

  if (existingFilterIndex >= 0) {

          console.log(`Removing filter for field ${field} as value is empty`);
          filters.splice(existingFilterIndex, 1);
      
  } else if (value) {
      filters.push({ field: field, operator: 'eq', value: value });
      console.log(`Added new filter for field ${field} with value ${value}`);
  }

  // Aggiorna il `filterValue` per assicurarsi che i cambiamenti vengano applicati
  console.log('Updated filterValue after textbox input change:', this.filterValue);
}


applyFilters(): void {
  console.log('Applying filters with filterValue:', this.filterValue);

  const cleanViewCode = this.viewCode.includes('.') ? this.viewCode.split('.').slice(0, -1).join('.') : this.viewCode;

  if (!this.filterValue.filters || this.filterValue.filters.length === 0) {
      this.router.navigate(['/d', cleanViewCode]);
      return;
  }
  const mongoDbFilter = this.filterValue.filters
      .filter((filter: any) => filter.value !== null && filter.value !== undefined) // Filtra solo i valori validi
      .map((filter: any) => {
          console.log('Building filter for field:', filter.field, 'with operator:', filter.operator, 'and value:', filter.value);

          const operatorMap = {
              'eq': '$eq',
              'neq': '$ne',
              'gt': '$gt',
              'gte': '$gte',
              'lt': '$lt',
              'lte': '$lte',
              'contains': '$regex',
              'doesnotcontain': '$not',
              'startswith': '$regex', 
              'endswith': '$regex'   

          };

          const isDateField = (filter.field.toLowerCase().includes('date') || filter.field.toLowerCase().includes('time'));
          var filterValue = typeof filter.value === 'object' && 'value' in filter.value ? filter.value.value : filter.value;

          if (isDateField) {
            const dateValue = new Date(filter.value);

            if (isNaN(dateValue.getTime())) {
                console.error('Invalid date value:', filter.value);
                throw new Error(`Invalid date value for field ${filter.field}`);
            }

            // Gestisci gli operatori relativi alle date
            if (filter.operator === 'lt') {
                // Usa la fine del giorno precedente
                const endOfDay = new Date(dateValue);
                endOfDay.setHours(23, 59, 59, 999);
                filterValue = endOfDay;
            } else if (filter.operator === 'gt') {
                // Usa l'inizio del giorno successivo
                const startOfDay = new Date(dateValue);
                startOfDay.setHours(0, 0, 0, 0);
                filterValue = startOfDay;
            } else {
                // Usa la data così com'è per altri operatori
                filterValue = dateValue;
            }
        }

          if (filter.operator === 'contains') {
            return {
                [filter.field]: {
                    [operatorMap[filter.operator]]: filterValue, 
                    $options: 'i' 
                }
            };
          }
          else if (filter.operator === 'doesnotcontain') {
            return {
                [filter.field]: {
                    [operatorMap[filter.operator]]: { $regex: filterValue, $options: 'i' } 
                }
            };
          }
          else if (filter.operator === 'startswith') {
              return {
                  [filter.field]: {
                      [operatorMap[filter.operator]]: `^${filterValue}`, 
                      $options: 'i'
                  }
              };
          } else if (filter.operator === 'endswith') {
              return {
                  [filter.field]: {
                      [operatorMap[filter.operator]]: `${filterValue}$`, 
                      $options: 'i'
                  }
              };
          }
          else {
              return {
                  [filter.field]: {
                      [operatorMap[filter.operator]]: filterValue
                  }
              };
          }
      });

  const filterLogic = this.filterValue.logic === 'or' ? '$or' : '$and';
  const filterObject = { [filterLogic]: mongoDbFilter };
  console.log('MongoDB filter object before encoding:', filterObject);

  //const filterString = encodeURIComponent(JSON.stringify(filterObject));
  const filterString = JSON.stringify(filterObject);
  console.log('Encoded filter string:', filterString);

  this.filterSharingService.setFilters(this.filterValue);
  this.router.navigate(['/d', cleanViewCode], { queryParams: { filter: filterString } });
}


  getDropDownData(fieldCode: string): void {
    if (!this.dropDownData[fieldCode]) {
        console.log(`Fetching dropdown data for fieldCode: ${fieldCode}`);
        this.gridService.getDropDownValues(fieldCode).subscribe(
            (data: any[]) => {
                if (data && data.length > 0) {
                    this.dropDownData[fieldCode] = data.map(item => ({ text: item.text, value: item.value }));
                } else {
                    this.dropDownData[fieldCode] = [{ text: 'Nessun dato disponibile', value: null }];
                }
                console.log(`Dropdown data for ${fieldCode}:`, this.dropDownData[fieldCode]);
            },
            (error) => {
                console.error(`Error loading dropdown values for ${fieldCode}`, error);
                this.dropDownData[fieldCode] = [{ text: 'Errore nel caricamento', value: null }];
            }
        );
    }
}
  

 

}
